import { defineSlotRecipe } from "@chakra-ui/react";

const basePrimary = {
    itemTrigger: {
        height: "62px",
        flexGrow: 1,
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "16px",
        padding: "16px 24px",
        bg: "canvas",
        cursor: "pointer",
        _hover: {
            bg: "canvas.dim"
        },
        _open: {
            bg: "canvas"
        },
        borderRadius: "0",
        minH: "62px",
        textStyle: "body.large",
        fontWeight: 600
    },
    itemContent: {},
    item: {
        _open: {
            bg: "transparent"
        }
    }
};

const accordionSlotRecipe = defineSlotRecipe({
    slots: [
        "item",
        "itemBody",
        "itemContent",
        "itemIndicator",
        "itemTrigger",
        "root"
    ],
    className: "chakra-accordion",

    base: {
        root: {
            width: "full",
            "--accordion-radius": "radii.l2"
        },
        item: {
            overflowAnchor: "none",
            _notFirst: {
                mt: "2"
            }
        },
        itemTrigger: {
            color: "text.soft",
            display: "flex",
            alignItems: "center",
            textAlign: "start",
            width: "full",
            outline: "0",
            gap: "3",
            fontWeight: "medium",
            _focusVisible: {
                outline: "2px solid",
                outlineColor: "colorPalette.focusRing"
            },
            _disabled: {
                layerStyle: "disabled"
            }
        },
        itemBody: {
            pt: "0",
            pb: "0"
        },
        itemContent: {
            overflow: "hidden",
            borderRadius: "0",
            _open: {
                animationName: "expand-height, fade-in",
                animationDuration: "moderate"
            },
            _closed: {
                animationName: "collapse-height, fade-out",
                animationDuration: "moderate"
            }
        },
        itemIndicator: {
            transition: "rotate 0.2s",
            transformOrigin: "center",
            color: "text",
            ml: "auto",
            _open: {
                rotate: "180deg"
            },
            _icon: {
                width: "24px",
                height: "24px"
            }
        }
    },

    variants: {
        variant: {
            outline: {
                item: {
                    borderBottomWidth: "1px",
                    _notFirst: {
                        mt: "0"
                    }
                },
                itemTrigger: {
                    cursor: "pointer"
                }
            },
            subtle: {
                itemTrigger: {
                    px: "var(--accordion-padding-x)"
                },
                itemContent: {
                    px: "var(--accordion-padding-x)"
                },
                Item: {
                    borderRadius: "var(--accordion-radius)",
                    _open: {
                        bg: "colorPalette.subtle"
                    }
                }
            },
            enclosed: {
                root: {
                    borderWidth: "1px",
                    borderRadius: "var(--accordion-radius)",
                    divideY: "1px",
                    overflow: "hidden"
                },
                itemTrigger: {
                    px: "var(--accordion-padding-x)"
                },
                itemContent: {
                    px: "var(--accordion-padding-x)"
                },
                Item: {
                    _open: {
                        bg: "bg.subtle"
                    }
                }
            },
            plain: {},
            primary: basePrimary,
            "primary-bordered": {
                root: {
                    borderWidth: "1px",
                    borderColor: "lines",
                    borderStyle: "solid",
                    divideY: "1px",
                    overflow: "hidden"
                },
                item: {
                    ...basePrimary.item,
                    borderColor: "lines",
                    _notFirst: {
                        mt: "0"
                    }
                },
                itemTrigger: basePrimary.itemTrigger,
                itemContent: basePrimary.itemContent
            }
        },

        size: {
            sm: {
                root: {
                    "--accordion-padding-x": "spacing.3",
                    "--accordion-padding-y": "spacing.2"
                },
                itemTrigger: {
                    textStyle: "sm",
                    py: "var(--accordion-padding-y)"
                }
            },
            md: {
                root: {
                    "--accordion-padding-x": "spacing.4",
                    "--accordion-padding-y": "spacing.2"
                },
                itemTrigger: {
                    textStyle: "md",
                    py: "var(--accordion-padding-y)"
                }
            },
            lg: {
                root: {
                    "--accordion-padding-x": "spacing.4.5",
                    "--accordion-padding-y": "spacing.2.5"
                },
                itemTrigger: {
                    textStyle: "lg",
                    py: "var(--accordion-padding-y)"
                }
            }
        }
    },

    defaultVariants: {
        size: "md",
        variant: "primary"
    }
});

export default accordionSlotRecipe;
